// extracted by mini-css-extract-plugin
export default {"TeacherPanel":"teacher_TeacherPanel__U6EW0"};